/**
 * PlatformARPlatformPageView
 *
 * Page component for PlatformARPlatformPageView
 * Path: /ar/platform
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { PlatformARPlatformPageView as __PlatformARPlatformPageView } from '@/components/traits/PlatformARPlatformPageView';
import { PlatformARPlatformAnalyticsView as __PlatformARPlatformAnalyticsView } from '@/components/traits/PlatformARPlatformAnalyticsView';
import { PlatformARDemoLaunchDeskView as __PlatformARDemoLaunchDeskView } from '@/components/traits/PlatformARDemoLaunchDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface PlatformARPlatformPageViewProps {
  // Add any page-level props here
}

export function PlatformARPlatformPageView(_props: PlatformARPlatformPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-platform:meta.title"],"description":["i18n/t","std-almadar-platform:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/platform"},{"locale":"ar","path":"/ar/platform"},{"locale":"sl","path":"/sl/platform"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__PlatformARPlatformPageView config={{ initPayload: __navState }} />
          <__PlatformARPlatformAnalyticsView config={{ initPayload: __navState }} />
          <__PlatformARDemoLaunchDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default PlatformARPlatformPageView;
